<template>
    <div>
        <div class="row">
            <form-input
                v-model="item.title"
                label="Title"
                :error-message="getError('title')"
                placeholder="Title"
                @blur="$emit('on-name-change', item.title)"
            />

            <form-input
                v-model="item.link"
                label="Link"
                :error-message="getError('link')"
                placeholder="Link"
            />

            <link-explanation include-resource-id-tip />
        </div>
    </div>
</template>

<script>
import BaseForm from '@/components/elements/BaseForm';
import LinkExplanation from '@/components/elements/LinkExplanation';

export default {
    components: {
        LinkExplanation
    },

    extends: BaseForm,

    computed: {
        isEditMode() {
            return !!this.item?.id;
        }
    }
};
</script>
